import React, { Fragment, useCallback, useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import RegisterCancelTokenAxios from '../../../../../core/proxies/RegisterCancelTokenAxios'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { debounce } from '../../../../helpers/common'
import { SearchListItem } from './SearchListItem'
import {
  changeIsLoading,
  changeSearchData,
  selectIsLoading,
  selectSearchData,
} from './store/slice'
import { postPeerAnalysisSearch } from './store/thunk'

const PADDING = 12

export const SearchList = ({ textSearch, onClickItem }) => {
  const dispatch = useDispatch()
  const searchRef = useRef()

  const locale = useSelector((state) => state.i18n.locale)
  const searchData = useSelector(selectSearchData)
  const isLoading = useSelector(selectIsLoading)

  const getMaxHeight = useMemo(() => {
    if (!searchRef.current) {
      return document.body.offsetHeight
    }

    const { top } = searchRef.current.getBoundingClientRect()
    return document.body.offsetHeight - top - PADDING * 2
  }, [searchRef.current, document.body.offsetHeight])

  const handleSearchData = useCallback(
    debounce((textSearch) => {
      if (textSearch.length > 1) {
        dispatch(postPeerAnalysisSearch({ term: textSearch }))
      } else {
        RegisterCancelTokenAxios.delete(
          `${process.env.REACT_APP_SERVICE_ENDPOINT}/DomesticSearch/search`,
        )
        dispatch(changeIsLoading(false))
        dispatch(changeSearchData([]))
      }
    }, 500),
    [],
  )

  useEffect(() => {
    handleSearchData(textSearch)
  }, [textSearch, locale])

  return (
    <div>
      {isLoading && <Loading />}
      {!isLoading && (
        <ScrollComponent autoHeight autoHeightMax={getMaxHeight}>
          <div ref={searchRef}>
            {textSearch.length !== 1 && (
              <>
                {searchData.map((item, index) => (
                  <Fragment key={index}>
                    {item.viewAllowed && (
                      <SearchListItem data={item} onClickItem={onClickItem} />
                    )}
                  </Fragment>
                ))}
              </>
            )}
            {textSearch.length === 1 && (
              <Element
                className="dFlex justifyContentCenter fstItalic"
                style={{ color: '#E0505B' }}
              >
                <Translate value="layout.header.search.INSET_AT_LEAST_2_LETTERS" />
              </Element>
            )}
          </div>
        </ScrollComponent>
      )}
    </div>
  )
}
